module.exports = __webpack_public_path__ + "img/alive-90-5.5d78a8f0.png";